import React from "react";
import classNames from "classnames";
import {
  FormGroup,
  Label,
  Alert,
  Card,
  CardSubtitle,
  CardText,
  Input,
  UncontrolledTooltip,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { SimpleLineIcon } from "../../../components/Icons";
import { popupActionOptions } from "./popupAppAction.utils";

const LinkButton = ({ onClick, children }) => (
  <a
    href="#"
    style={{ textDecoration: "underline" }}
    onClick={e => {
      e.preventDefault();
      onClick();
    }}
  >
    {children}
  </a>
);

const renderActionContent = ({
  selectedAction,
  keyword,
  product,
  collection,
  hasKeywordError,
  keywordErrorNode,
  onKeywordChange,
  onOpenProductModal,
  onOpenCollectionModal,
}) => {
  switch (selectedAction) {
    case "NONE":
      return (
        <Alert isOpen color="info">
          <strong>Info: </strong>
          Do nothing, user will not redirect to any screen when they click this slider through app.
        </Alert>
      );
    case "PRODUCT_DETAIL_SCREEN":
      if (product?.id) {
        return (
          <Card body>
            <div style={{ fontSize: ".65rem" }} className="mb-3">
              PRODUCT (ID: {product.id}){" "}
              <LinkButton onClick={onOpenProductModal}>Choose another product</LinkButton>
            </div>
            <CardSubtitle>{product.display_name || "-"}</CardSubtitle>
            <CardText style={{ fontSize: ".75rem" }} className="text-uppercase mb-0">
              {product.category || "-"} / {product.SKU || "-"}
            </CardText>
          </Card>
        );
      }
      return (
        <Alert isOpen color="info">
          <strong>Info: </strong>
          You haven't selected a product.{" "}
          <LinkButton onClick={onOpenProductModal}>Choose a product</LinkButton>
        </Alert>
      );
    case "PRODUCT_SEARCH_SCREEN":
      return (
        <FormGroup className={classNames({ "has-danger has-feedback mb-0": hasKeywordError })}>
          <Input
            type="text"
            name="_popupBannerActionKeyword"
            placeholder="Enter keyword"
            value={keyword}
            onChange={({ target: { value } }) => onKeywordChange(value)}
          />
          {keywordErrorNode}
        </FormGroup>
      );
    case "COLLECTION_DETAIL_SCREEN":
      if (collection?.slug) {
        return (
          <Card body>
            <div style={{ fontSize: ".65rem" }} className="mb-3">
              COLLECTION (ID: {collection.id || "-"}){" "}
              <LinkButton onClick={onOpenCollectionModal}>Choose another collection</LinkButton>
            </div>
            <CardSubtitle>
              <strong>{collection.name || "-"}</strong>
            </CardSubtitle>
            <CardText style={{ fontSize: ".75rem" }} className="mb-0">
              <span className="text-uppercase">{collection.category || "-"}</span> / {collection.slug}
            </CardText>
          </Card>
        );
      }
      return (
        <Alert isOpen color="info">
          <strong>Info: </strong>
          You haven't selected a collection.{" "}
          <LinkButton onClick={onOpenCollectionModal}>Choose a collection</LinkButton>
        </Alert>
      );
    default:
      return null;
  }
};

const ActionForAppSection = ({
  selectedAction,
  dropdownOpen,
  keyword,
  product,
  collection,
  hasDataError,
  hasKeywordError,
  dataErrorNode,
  keywordErrorNode,
  onToggleDropdown,
  onSelectAction,
  onKeywordChange,
  onOpenProductModal,
  onOpenCollectionModal,
}) => {
  const selected = popupActionOptions.find(item => item.type === selectedAction);
  const label = selected ? selected.label : "Choose an action...";

  return (
    <FormGroup className={classNames({ "has-danger has-feedback": hasDataError })}>
      <Label id="actionForAppLabel">
        <span>Action for App</span>
        <SimpleLineIcon iconType="question" className="ml-2" />
      </Label>
      <UncontrolledTooltip innerClassName="text-left" placement="right" target="actionForAppLabel">
        Add action/behavior when user clicked the slider through our app.
      </UncontrolledTooltip>
      <div className="mb-2">
        <ButtonDropdown size="sm" isOpen={dropdownOpen} toggle={onToggleDropdown}>
          <DropdownToggle caret>{label}</DropdownToggle>
          <DropdownMenu>
            {popupActionOptions.map(item => (
              <DropdownItem onClick={() => onSelectAction(item.type)} key={item.type}>
                {item.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </ButtonDropdown>
      </div>
      {renderActionContent({
        selectedAction,
        keyword,
        product,
        collection,
        hasKeywordError,
        keywordErrorNode,
        onKeywordChange,
        onOpenProductModal,
        onOpenCollectionModal,
      })}
      {dataErrorNode}
    </FormGroup>
  );
};

export default ActionForAppSection;
